import React, { FC } from 'react';
import { Box } from '@mui/system';

const ShortPresentationItem: FC<{ title: string; value: string; underline?: boolean }> = ({
  title,
  value,
  underline,
}) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', mb: 2 }}>
    <span style={{ color: '#888F99', fontSize: 13, fontWeight: 400, marginBottom: 8 }}>{title}</span>
    <span
      style={{
        fontWeight: 400,
        textDecorationColor: underline ? '#4782DA' : undefined,
        textDecorationLine: underline ? 'underline' : undefined,
        color: underline ? '#4782DA' : undefined,
        // cursor: underline ? 'pointer' : void 0,
      }}
    >
      {value}
    </span>
  </Box>
);

export { ShortPresentationItem };
